$(function () {
    function initShowMoreList() {
        const maxVisible = 3;

        $('.show-more-list').each(function () {
            const block = $(this),
                list = block.find('.list-group'),
                items = list.children('.item'),
                btn = block.find('.show-more-btn');

            btn.off('click');

            if ($(window).width() <= 767 && items.length > maxVisible) {
                const hiddenCount = items.length - maxVisible,
                    showText = btn.data('text').replace('%s', hiddenCount),
                    hideText = btn.data('hide');

                btn.children('p').text(showText);
                btn.css('display', 'flex');

                btn.on('click', function () {
                    block.toggleClass('expanded');

                    if (block.hasClass('expanded')) {
                        btn.children('p').text(hideText);
                    } else {
                        btn.children('p').text(showText);

                        $('html, body').animate({
                            scrollTop: block.offset().top - 20,
                        }, 200);
                    }
                });
            } else {
                block.removeClass('expanded');
            }
        });
    }

    initShowMoreList();

    $(window).on('resize orientationchange', function () {
        initShowMoreList();
    });

    $('.hs-product-final-cta__scroll').on('click', function (e) {
        e.preventDefault();
        const target = document.getElementById('product-purchase-block');
        if (!target) {
            return;
        }
        const offset = 20;
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        $('html, body').animate({ scrollTop: top }, 400);
    });
});
